import React, { useState } from 'react'
import moment from 'moment'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import DatePicker from './date_picker'

// Pill-style trigger that opens a calendar popover. Same public API as
// before: `value` (moment-parseable), `onChange` (receives 'YYYY-MM-DD' on
// Save, '' on Clear — nothing is emitted until then), `placeholder`,
// `displayPrefix`, `icon` (a lucide component).
const DateSelect = ({ value, onChange, placeholder, displayPrefix, icon: Icon }) => {
  const [open, setOpen] = useState(false)
  const [pending, setPending] = useState('')

  let displayValue = null
  if (value) {
    const d = moment(value)
    const formatted = d.isValid() ? d.format('Do MMM YYYY') : value
    displayValue = (displayPrefix || '') + formatted
  }

  const onOpenChange = (next) => {
    if (next) setPending(value || '')
    setOpen(next)
  }

  const onSave = () => {
    setOpen(false)
    onChange(pending)
  }

  const onClear = () => {
    setOpen(false)
    onChange('')
  }

  const onCancel = () => {
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger
        className={
          'inline-flex h-9 select-none items-center gap-2 whitespace-nowrap rounded-lg border bg-background px-3.5 text-[13.5px] font-medium text-foreground transition-colors hover:bg-muted ' +
          (displayValue ? 'border-border' : 'border-dashed border-border text-muted-foreground')
        }
      >
        {Icon && <Icon className="size-3.5 text-muted-foreground" />}
        <span>{displayValue || placeholder || 'Select'}</span>
        <ChevronDown className="size-3.5 text-muted-foreground" />
      </PopoverTrigger>
      <PopoverContent align="center" className="w-auto">
        <DatePicker value={pending} onChange={setPending} />
        <div className="mt-3 flex items-center justify-between gap-2 border-t pt-3">
          <Button size="sm" variant="ghost" onClick={onClear}>Clear</Button>
          <div className="flex gap-2">
            <Button size="sm" variant="ghost" onClick={onCancel}>Cancel</Button>
            <Button size="sm" onClick={onSave}>Save</Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default DateSelect
